import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'

export const heroFragment = gql`
  ${responsiveImageFragment}
  fragment HeroFragment on HeroRecord {
    id
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
    introImage {
      id
      responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
        ...ResponsiveImageFragment
      }
    }
    introLeftText
    introRightText
    title
    forceTitleOnTop
    subtitle
    leftMedia {
      id
      videoUrl
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
    rightMedia {
      id
      videoUrl
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
    bottomImage {
      id
      responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
        ...ResponsiveImageFragment
      }
    }
  }
`
